module.exports = __webpack_public_path__ + "static/media/mi-15.a78eeaf5.jpg";